const INJECT_RE = /<script|javascript:|data:|vbscript:|on\w+\s*=/i;
const HTML_TAG_RE = /<[^>]*>/g;
const EMAIL_RE = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;

/** Strip HTML tags and trim. Returns empty string if injection detected. */
export function sanitizeText(val, maxLen = 500) {
  if (typeof val !== 'string') return '';
  const stripped = val.replace(HTML_TAG_RE, '').trim();
  if (INJECT_RE.test(stripped)) return '';
  return stripped.slice(0, maxLen);
}

export function validateEmail(email) {
  return typeof email === 'string' &&
    EMAIL_RE.test(email.trim()) &&
    email.trim().length <= 254;
}

/** Validate a contact form payload. Returns { ok, errors }. */
export function validateContact({ name, email, subject, message, honeypot }) {
  if (honeypot) return { ok: false, errors: {} }; // silent bot block

  const errors = {};

  const sName = sanitizeText(name, 100);
  if (!sName || sName.length < 2) errors.name = 'Vardas privalomas (min. 2 simboliai)';

  if (!validateEmail(email)) errors.email = 'Neteisingas el. pašto adresas';

  const sSubject = sanitizeText(subject, 200);
  if (!sSubject) errors.subject = 'Tema privaloma';

  const sMessage = sanitizeText(message, 2000);
  if (!sMessage || sMessage.length < 10) errors.message = 'Žinutė privaloma (min. 10 simbolių)';

  return { ok: Object.keys(errors).length === 0, errors };
}
